import React from 'react';
import { Button } from '@mui/material';


/**
 * A React component that renders a "Clear All" button with a specific design.
 * 
 * @param {Object} props - The component props.
 * @param {Function} props.onClear - The callback function to call when the button is clicked.
 */
const ClearAll = ({
  /**
   * The callback function to call when the button is clicked.
   */
  onClear
}) => {
  return (
    <div>
      <Button
        /**
         * The button's onClick event handler.
         */
        onClick={onClear} 
        sx={{
          /**
           * Custom styles for the button
           */
          border: 'solid 0.25px #15465d',
          textTransform: 'none',
          margin: '10px',
          padding: '10px 30px',
          textAlign: 'center',
          transition: '0.5s',
          backgroundSize: '200% auto',
          color: 'white',
          borderRadius: '10px',
          display: 'block',
          fontWeight: 700,
          boxShadow: '0px 0px 14px -7px #2b8cb9',
          backgroundImage: 'linear-gradient(45deg, #064D6F 0%, #2b8cb9 51%, #1BB2F8 100%)',
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            backgroundPosition: 'right center',
            color: '#fff',
            textDecoration: 'none'
          },
          '&:active': {
            transform: 'scale(0.95)'
          }
        }}
      >
        Clear All
      </Button>
    </div>
  );
};

/**
 * Exports the ClearAll component as the default export.
 */
export default ClearAll;